import { HugeiconsIcon } from "@hugeicons/react";
import { Cancel01Icon, Search01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { Button } from "@workspace/frontend-ui";
import type { FC } from "react";

type Props = {
  term: string;
  onRemove: (term: string) => void;
  onSelect: (term: string) => void;
};

const RecentSearchChip: FC<Props> = ({ term, onRemove, onSelect }) => (
  <div className="flex gap-x-0 items-center justify-start group rounded-full bg-secondary text-muted-foreground hover:text-foreground hover:bg-muted/50">
    <Button
      variant="unstyled"
      className="rounded-tl-full! transition-none! pr-1! rounded-bl-full! block md:hidden group-hover:block! bg-none!"
      onClick={() => onRemove(term)}
    >
      <HugeiconsIcon
        icon={Cancel01Icon}
        size={16}
        className="text-muted-foreground"
      />
    </Button>
    <Button
      onClick={() => onSelect(term)}
      variant="unstyled"
      className="group-hover:pl-0! max-md:pl-0! transition-none! rounded-tr-full! rounded-br-full! bg-none!"
    >
      <HugeiconsIcon
        className="hidden md:block group-hover:hidden!"
        icon={Search01Icon}
      />
      {term}
    </Button>
  </div>
);

export default RecentSearchChip;
